export enum EmergencyType {
  ANTEPARTUM = 'ANTEPARTUM',

  LABOUR = 'LABOUR',

  POSTPARTUM = 'POSTPARTUM',

  NEONATAL = 'NEONATAL',
}
